export const name = 'rnAbbr';

export default function rnAbbr(rnFormat) {
  'ngInject';

  return rnFormat.abbr;
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/locale/format/abbr.filter.js